<template>
    <div class="animated fadeIn">
        <b-modal ref="modal-newRule" scrollable centered button-size="sm" v-on:hide="hideModal">
            <template #modal-title>
                <i class="fas fa-random"></i>&nbsp; NOVA REGRA
            </template>
            <FormulateInput
              type="select"
              :disabled="isEditing"
              required
              v-model="form.tipoRegra"
              :options="boardIsCobranca ? typeOptionsIfCobranca : typeOptionsDefault"
              label="Tipo de Regra:"
              id="selectType"
              placeholder="Selecione o Tipo">
            </FormulateInput>
            <FormulateInput
              v-show="form.tipoRegra === 'DIAS ATRASO'"
              v-model="form.tipoDiaAtraso"
              :disabled="isEditing"
              type="radio"
              error-behavior="live"
              :options="LateDaysOptions"
            />
            <div class="newRule__inputs__container">
                <NxInput
                  validation="min:1"
                  :validation-messages="{
                      min: 'Valor deve ser maior que zero.'
                  }"
                  error-behavior="value"
                  required
                  name="timeLimit"
                  type="number"
                  :label="formatTimeLimitLabel(form.tipoRegra)"
                  placeholder="Digite o tempo limite"
                  :value="form.tempoAtraso"
                  v-model="form.tempoAtraso">
                </NxInput>
                <NxSelectQuadroColuna
                  required
                  :value="form.boardColumnId"
                  :boardId="column.board.id"
                  :onlyActive="true"
                  @update:value="form.boardColumnId = $event" />
            </div>
            <template #modal-footer>
                <div class="w-100 text-right">
                    <button type="button" class="btn rounded btn-default btn-sm text-secundary" v-on:click="onClear"
                        v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonClear"><i class="fa fa-minus-circle mr-1"></i>
                        <span class="d-md-down-none">{{ $lang.Common.Buttons.Clear }}</span></button>&nbsp;
                    <button :disabled="!readyToSave" type="button" class="btn rounded btn-third btn-sm" v-on:click="onSave"
                        v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonSave"> <i class="fas fa-check-circle mr-1"></i>
                        <span class="d-md-down-none">{{ $lang.Common.Buttons.Save }}</span></button>&nbsp;
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import { NxSelectQuadroColuna } from '@/components/nexum/components/custom-selects/index.js'
import { toast } from '@/shared/utils/UIHelper'
import columnRuleTypes from '@/views/private/crm/board/modal/collumns/movimentacao-coluna/enumTiposRegra.js'
import boardTypes from '@/enums/enumBoardTypes.js'
import BoardRepository from '@/shared/http/repositories/crm/board.js'
import MovAutoCardRepository from '@/shared/http/repositories/crm/movimentacaoAutoCard.js'

export default {
  name: 'ModalNewRule',
  props: {
    column: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      required: true
    },
    isEditing: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      ruleTypes: columnRuleTypes,
      boardTypes: boardTypes,
      boardIsCobranca: false,
      form: {
        tipoRegra: null,
        tipoDiaAtraso: 'RANGE',
        tempoAtraso: null,
        boardColumnId: null,
        inative: false
      },
      typeOptionsDefault: {
        'TEMPO ETAPA': 'Tempo na Etapa'
      },
      typeOptionsIfCobranca: {
        'TEMPO ETAPA': 'Tempo na Etapa',
        'DIAS ATRASO': 'Dias de atraso'
      },
      LateDaysOptions: {
        'RANGE': 'Após o dia',
        'IGUAL': 'Igual ao dia'
      },
      boardColumnOptions: []
    }
  },
  components: { NxSelectQuadroColuna },
  computed: {
    readyToSave () {
      return this.form && this.form.tipoRegra && this.form.tempoAtraso && this.form.boardColumnId
    }
  },
  created () {
    this.onCheckBoardTypeCobranca()
    this.onLoadBoardColumns()
  },
  mounted () {
    if (this.isEditing) {
      this.dataToForm()
    }
    this.showModal()
  },
  methods: {
    onLoadBoardColumns () {

    },
    showModal () {
      this.$refs['modal-newRule'].show()
    },
    hideModal () {
      this.$emit('HideModal')
    },
    hideModalSucess () {
      this.$emit('Reload')
    },
    setColumnAndIndex (column, index) {
      this.column = column
      this.index = index
    },
    openNewRuleModal () {
      this.newRuleModalOpen = true
    },
    closeNewRuleModal () {
      this.newRuleModalOpen = false
    },
    onSave () {
      if (this.isEditing) {
        this.onEdit()
        return
      }

      let data = this.formatData()
      let idCurrentBoardColumn = this.column.id

      MovAutoCardRepository.CreateBoardColumn(idCurrentBoardColumn, data)
        .then(() => {
          toast.success('A regra foi salva com sucesso!', 'Parabéns')
          this.hideModalSucess()
        })
        .catch((e) => {
          toast.error('Não foi possível salvar a regra.', 'Desculpe')
          console.error(e)
        })
    },
    onEdit () {
      let data = this.formatData()
      MovAutoCardRepository.Update(data)
        .then(() => {
          toast.success('A regra foi editada com sucesso!', 'Parabéns')
          this.hideModalSucess()
        })
        .catch((e) => {
          toast.error('Não foi possível editar a regra.', 'Desculpe')
          console.error(e)
        })
    },
    onClear () {
      this.$root.$emit('clearForm')
    },
    async onCheckBoardTypeCobranca () {
      await BoardRepository.GetById(this.column.board.id)
        .then((response) => {
          this.boardIsCobranca = response.data.tipoBoard === this.boardTypes.COBRANCA
        })
        .catch((e) => {
          console.error(e)
        })
    },
    formatData () {
      let type
      switch (this.form.tipoRegra) {
        case this.ruleTypes.TEMPO:
          type = 1
          break
        case this.ruleTypes.DIAS:
          type = 0
          break
      }
      let time = type === 0 ? this.daysToHours(this.form.tempoAtraso) : parseInt(this.form.tempoAtraso)
      let bcId = parseInt(this.form.boardColumnId)
      let data = {
        tipoRegra: type,
        isEqualDiaAtraso: this.form.tipoDiaAtraso === 'IGUAL',
        horas: time,
        boardColumnDestino: bcId,
        inative: this.form.inative,
        id: this.form.id ? this.form.id : null
      }
      return data
    },
    dataToForm () {
      let tempoAtraso = (this.isEditing.tipoRegra === this.ruleTypes.DIAS) ? this.hoursToDays(this.isEditing.tempoAtraso) : this.isEditing.tempoAtraso
      this.form = {
        tipoRegra: this.isEditing.tipoRegra === 'DIA ATRASO ESPECIFICO' ? 'DIAS ATRASO' : this.isEditing.tipoRegra,
        tempoAtraso: tempoAtraso,
        inative: this.isEditing.inative,
        tipoDiaAtraso: this.isEditing.tipoRegra === this.ruleTypes.DIAS ? 'RANGE' : 'IGUAL',
        boardColumnId: this.isEditing.boardColumn.id,
        id: this.isEditing.id
      }
    },
    formatTempo (obj) {
      switch (obj.tipoRegra) {
        case this.ruleTypes.TEMPO:
          return `${obj.tempoAtraso} horas`
        case this.ruleTypes.DIAS:
          return `${this.hoursToDays(obj.tempoAtraso)} dias`
        default:
          return obj.tempoAtraso
      }
    },
    formatTimeLimitLabel (time) {
      let type = (time && time.value) ? time.value : time
      switch (type) {
        case this.ruleTypes.TEMPO:
          return 'Tempo máximo na etapa'
        case this.ruleTypes.DIAS:
          return 'Dias em atraso'
        default:
          return 'Digite o Tempo'
      }
    },
    daysToHours (time) {
      return parseInt(time * 24)
    },
    hoursToDays (time) {
      return parseInt(time / 24)
    }
  }
}

</script>
<style lang="scss">
.formulate-input-element.formulate-input-element--textarea {
    max-width: 100% !important;
}

.newRule__inputs__container {
    display: flex;
    gap: 1rem;
    justify-content: space-between;

    .formulate-input {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/board/modal/collumns/movimentacao-coluna/ModalNewRule.vue